import { css, Theme } from '@emotion/react'
import { alpha } from '@mui/material/styles'

export const tabsContainer = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`

export const tab =
  ({ active, error, disabled }: { active?: boolean; error?: boolean; disabled?: boolean }) =>
  (theme: Theme) =>
    css`
      background: ${active ? (error ? alpha(theme.colors.red, 0.1) : theme.colors.grayHover) : 'none'};
      color: ${error ? theme.colors.red : theme.typographyColors.typographyTwo};
      font-weight: 600;
      padding: 12px 12px 8px;
      border-radius: 12px;
      cursor: pointer;

      ${disabled &&
      css`
        color: ${theme.colors.typographyThree};

        cursor: not-allowed;
      `}
    `
